// GLOBAL THEME JS

// DOM SELECTION 

//Functions Site Wide

// HEADER

// Mobile Nav toggle open
document.querySelector("#toggle").addEventListener("click", function() {
  this.classList.toggle("active");
  document.querySelector("#overlay").classList.toggle("open");
  document.body.classList.toggle("overflow-hidden");
});

// Header Mobile Menu Accordion

const mobNavAcc = document.getElementsByClassName("accordion-mobile");

for (i = 0; i < mobNavAcc.length; i++) {
  mobNavAcc[i].onclick = function() {

	if( !this.classList.contains('active') ){
    	closeAll();
    }
	
  this.classList.toggle("active");
    const panel = this.nextElementSibling;
    if (panel.style.maxHeight){
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    } 
  }
  
}

function closeAll(){
	 for (i = 0; i < mobNavAcc.length; i++) {
    	mobNavAcc[i].classList.remove("active");
        mobNavAcc[i].nextElementSibling.style.maxHeight = null;
    }
}


// Search Function

// Search Bar Wrapper
const searchWrapper = document.querySelector('.header-search-bar--wrapper');
const searchInner = document.querySelector('.search-inner');
const searchForm = document.querySelector('.header-search-bar');

var predictiveSearchInput = document.getElementById('searchInputField');
var timer;

var offcanvasSearch = document.getElementById('searchResult');
var bsOffcanvas = document.getElementById('searchResult');

if(predictiveSearchInput != null) {
    predictiveSearchInput.addEventListener('input', function(e) {

        clearTimeout(timer);

        if(predictiveSearchInput.value) {
            timer = setTimeout(fetchPredictiveSearch, 500);
        }
        
    });
}

function fetchPredictiveSearch() {
    fetch(`/search/suggest.json?q=${predictiveSearchInput.value}&resources[type]=product`)
    .then(resp => resp.json())
    .then(data => { 
        console.log(data);

        var products = data.resources.results.products;

        document.getElementById('search_results_body').innerHTML = '';

        products.forEach(function(product, index) {
            document.getElementById('search_results_body').innerHTML += `
                <a href="${product.url}">
                    <div class="flex items-start mb-10" style="w-320">
                    <img src="${product.image}" class="w-100">
                    <div class="ml-10">
                        <p class="uppercase mt-0 mb-5">${product.title}</p>
                        <p class="m-0" style="color:#edd100;">$${product.price}</p>
                    </div>
                </div>
                </a>
            `
        });
        bsOffcanvas.classList.add("block");
    });
}

// Tabs

function activateTabs(evt, tabName) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tab-contents");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("tab-button");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  document.getElementById(tabName).style.display = "block";
  evt.currentTarget.className += " active";
}

// Localization form JavaScript

class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
      button: this.querySelector('button'),
      panel: this.querySelector('ul'),
    };
    this.elements.button.addEventListener('click', this.openSelector.bind(this));
    this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

    this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
  }

  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.setAttribute('hidden', true);
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    this.hidePanel();
    this.elements.button.focus();
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }

  openSelector() {
    this.elements.button.focus();
    this.elements.panel.toggleAttribute('hidden');
    this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
  }

  closeSelector(event) {
    const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
    }
  }
}
customElements.define('localization-form', LocalizationForm);


      document.addEventListener('DOMContentLoaded', function() {
  const searchWrapper = document.querySelector('.search-wrapper');
  const searchButton = document.querySelector('.search-button');
  const searchInput = document.querySelector('.search-input');
  const predictiveResults = document.getElementById('predictive-search-results');
  const searchIcon = document.querySelector('.search-button svg');
  
  // Toggle search bar on button click
  searchButton.addEventListener('click', function(e) {
    if (!searchWrapper.classList.contains('active')) {
      e.preventDefault();
      searchWrapper.classList.add('active');
      searchInput.focus();
      searchIcon.classList.add('svg-active');
      console.log(searchIcon);
    }
  });
  
  // Close search when clicking outside
  document.addEventListener('click', function(e) {
    if (!searchWrapper.contains(e.target)) {
      searchWrapper.classList.remove('active');
      predictiveResults.innerHTML = '';
      predictiveResults.style.display = 'none';
      searchIcon.classList.remove('svg-active');
    }
  });
  
  // Predictive search functionality
  let debounceTimer;
  
  searchInput.addEventListener('input', function() {
    clearTimeout(debounceTimer);
    
    const searchTerm = searchInput.value.trim();
    
    if (searchTerm.length > 2) {
      debounceTimer = setTimeout(() => {
        fetchPredictiveSearch(searchTerm);
      }, 300);
    } else {
      predictiveResults.innerHTML = '';
      predictiveResults.style.display = 'none';
    }
  });
  
  function fetchPredictiveSearch(searchTerm) {
    // Show loading indicator
    predictiveResults.innerHTML = '<div class="loading">Searching...</div>';
    predictiveResults.style.display = 'block';
    
    fetch(`/search/suggest.json?q=${encodeURIComponent(searchTerm)}&resources[type]=product,collection,page,article`)
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(data => {
        renderPredictiveResults(data, searchTerm);
      })
      .catch(error => {
        console.error('Error fetching predictive search results:', error);
        predictiveResults.innerHTML = '<div class="error">Error loading results</div>';
      });
  }
  
  function renderPredictiveResults(data, searchTerm) {
    let resultsHTML = '';
    const resources = data.resources.results;
    
    // Products
    if (resources.products && resources.products.length > 0) {
      resultsHTML += '<div class="predictive-products"><h3>Products</h3><ul>';
      resources.products.slice(0, 4).forEach(product => {
        const imageUrl = product.featured_image ? product.featured_image.url : '';
        const price = product.price ? `$${product.price}` : '';
        
        resultsHTML += `
          <li>
            <a href="${product.url}">
              ${imageUrl ? `<img src="${imageUrl}" alt="${product.title}" width="50">` : ''}
              <div class="product-details">
                <span class="product-title">${product.title}</span>
                ${price ? `<span class="product-price">${price}</span>` : ''}
              </div>
            </a>
          </li>
        `;
      });
      resultsHTML += '</ul></div>';
    }
    
    // Collections
    if (resources.collections && resources.collections.length > 0) {
      resultsHTML += '<div class="predictive-collections"><h3>Collections</h3><ul>';
      resources.collections.slice(0, 2).forEach(collection => {
        resultsHTML += `
          <li>
            <a href="${collection.url}">${collection.title}</a>
          </li>
        `;
      });
      resultsHTML += '</ul></div>';
    }
    
    // Pages
    if (resources.pages && resources.pages.length > 0) {
      resultsHTML += '<div class="predictive-pages"><h3>Pages</h3><ul>';
      resources.pages.slice(0, 2).forEach(page => {
        resultsHTML += `
          <li>
            <a href="${page.url}">${page.title}</a>
          </li>
        `;
      });
      resultsHTML += '</ul></div>';
    }
    
    // View all results link
    resultsHTML += `
      <div class="view-all">
        <a href="/search?q=${encodeURIComponent(searchTerm)}&type=product,article,page,collection">
          View all results for "${searchTerm}"
        </a>
      </div>
    `;
    
    if (resultsHTML) {
      predictiveResults.innerHTML = resultsHTML;
      predictiveResults.style.display = 'block';
    } else {
      predictiveResults.innerHTML = '<div class="no-results">No results found</div>';
      predictiveResults.style.display = 'block';
    }
  }
});
